import { Chip, Stack, styled, Typography } from '@mui/material';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReasonInputBaseProps } from './BaseInput';
import FieldFreeText from './FieldFreeText';

interface ShortcutTranslation {
    label: string;
    value: string;
}

export default function ScheduleInput(props: ReasonInputBaseProps) {
    const { t } = useTranslation('feedback', { keyPrefix: 'declineDialog.setReasonDetails' });
    const shortcuts = t('reasonInput.schedule.shortcuts', { returnObjects: true }) as ShortcutTranslation[];
    const { setValue } = props;
    const { control } = props;
    const value = useWatch({ control, name: 'freeText' });

    const [ valueInsertedFromShortcuts, setValueInsertedFromShortcuts ] = useState('');

    const handleShortcutClick = (shortcut: ShortcutTranslation) => {
        const valueManuallyEdited = value && value !== valueInsertedFromShortcuts;
        let newValue = '';

        if (valueManuallyEdited) {
            newValue = `${ value }. ${ shortcut.value }`;
        } else if (!value) {
            newValue = shortcut.value;
        } else if (value.startsWith('-')) {
            newValue = `${ value }\n- ${ shortcut.value }`;
        } else {
            newValue = `- ${ value }\n- ${ shortcut.value }`;
        }

        setValue('freeText', newValue);
        setValueInsertedFromShortcuts(newValue);
    };

    return (
        <>
            <Typography variant="subtitle2">{ t('reasonInput.schedule.label') }</Typography>
            <ShortcutsContainer>
                { shortcuts.map(shortcut => (
                    <Shortcut key={ shortcut.label }
                        label={ shortcut.label }
                        size="small"
                        onClick={ () => handleShortcutClick(shortcut) } />
                )) }
            </ShortcutsContainer>
            <FieldFreeText { ...props } />
        </>
    );
}

const ShortcutsContainer = styled(Stack)(({ theme }) => ({
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(1),
    flexDirection: 'row',
    flexWrap: 'wrap'
}));

const Shortcut = styled(Chip)(({ theme }) => ({
    cursor: 'pointer',

    '&:hover': {
        backgroundColor: theme.palette.action.hover
    }
}));
